import {useEffect, useState} from "react";
import {loadLocalEventerPod, LocalEventerPod} from "../../../eventer-pod/client/local-eventer-pod";

export function useW2d2dPod(): LocalEventerPod | undefined {
    const [pod, setPod] = useState<LocalEventerPod | undefined>(undefined);

    useEffect(() => {
        let active = true;
        loadLocalEventerPod("w2d2d")
            .then((localEventerPod) => {
                if (active) {
                    setPod(localEventerPod);
                }
            });
        return () => {
            active = false;
        };
    }, []);

    return pod;
}
